<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="col d-flex mb-2" style="border: 1px dotted #206c79; background-color: #ffffff;padding: 26px 32px 24px 27px;" *ngIf="isExtensioninstalled != true">
  <div class="col-md-2 mr-6" style="overflow:hidden">
    <img src="../../../assets/group.png" style="width: 206px;
    height: 161px;">
  </div>
  <div class="col">
    <p class="f-16">
      Webbtree's Chrome Extension helps you source, enrich and nurture talent from across the web
    </p>
    <p class="f-14 d-flex " style="color: #777777;"><span><i class="fas fa-circle mr-3 f-10"
          style="color: #777777;"></i></span>Grab candidates you discover on LinkedIn, GitHub, Stack Overflow,
      Kaggle,
      Naukri, Career Builder and build talent pools.</p>
    <p class="f-14 d-flex mb-0" style="color: #777777;"> <span><i class="fas fa-circle mr-3 f-10"
          style="color: #777777;"></i></span> Find contact number, email addresses and social profiles of candidate
      you discover. </p>

    <div class="pointer">
      <button data-testid="auto-app-searchtoolbox-v2-button-1" class="btn-trms-medium m-auto" (click)="routeURL()">
        Add chrome extension</button>
    </div>
  </div>
</div>


<!-- Landing Page -->
<div class="landing-page-background" *ngIf="!showSearchHistoryPage && !showSearchPlatformPage">
  <div>
    <h1 class="landing-page-heading">X-Ray searching across the web</h1>
    <span class="wc-btn history-button landing-page-history-button" (click)="showHistoryPage('landingPage')"> History </span>
    <p class="landing-page-text">
      Find candidate from across the web based on search parameters such as - skills, job titles, locations,
      <br>
      companies. Our search is precise and more powerful than traditional search engine X-Ray methods and helps to
      <br>
      overcome various social sites' search limitations.
    </p>


    <div class="row">
      <div class="col-md-8 mx-auto">
        <div class="col px-0 mb-6 personsearchdiv">
          <div class="col wccard py-3 pp-border">
            <div class="d-flex justify-content-between">
              <div class="px-3">
                <p class="font-weight-500 f-18">Person Search
                </p>
                <p class="f-12 gray-text">
                  Looking for the linkedin profile of someone you know using their details like name,
                  designation , company etc.
                  </p>
                  <p class="text-webbtree-green mb-0 mt-4">
                    <span class="landing-page-platform-name font-weight-500" (click)="displayPlatformPage('Person Search')">
                      Search
                      </span>
                  </p>
              </div>
              <div class="pr-3 h-120" >
                <img src="./../../../assets/search/toolbox-v2/profiling-two-color-1.png" class="">
              </div>
              </div>
            </div>
        </div>

        <div class="row mb-6">
        <div class="col-md-6">
          <div class="landing-page-platform-partitions2 wccard ml-auto  p-3">
          <h3 class="landing-page-platform-headings">General</h3>
          <p class="landing-page-platforms-description">
            Access the most relevant profiles without any restrictions by platforms.
          </p>
          <div class="row">
            <div class="col landing-page-platform-names-div">
              <li class="landing-page-platform-name" (click)="displayPlatformPage('General', 'LinkedIn')">LinkedIn</li>
              <li class="landing-page-platform-name" (click)="displayPlatformPage('General', 'Xing')">Xing</li>
              <li class="landing-page-platform-name" (click)="displayPlatformPage('General', 'Quora')">Quora</li>
              <li class="landing-page-platform-name" (click)="displayPlatformPage('General', 'Twitter')">Twitter</li>
            </div>
            <div class="col position-relative">
              <img src="./../../../assets/search/toolbox-v2/general-platforms.png"
              class="landing-page-platform-images position-absolute general-rb5020">
            </div>
          </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="landing-page-platform-partitions2 wccard  p-3">
            <h3 class="landing-page-platform-headings">Technical</h3>
            <p class="landing-page-platforms-description">
              Get results from different technical forums using a tool tailored for the same.
            </p>
            <div class="row">
              <div class="col landing-page-platform-names-div">
                <li class="landing-page-platform-name" (click)="displayPlatformPage('Technical', 'LinkedIn')">LinkedIn</li>
                <li class="landing-page-platform-name" (click)="displayPlatformPage('Technical', 'AngelList')">AngelList</li>
                <li class="landing-page-platform-name" (click)="displayPlatformPage('Technical', 'Kaggle')">Kaggle</li>
                <li class="landing-page-platform-name" (click)="displayPlatformPage('Technical', 'GitHub')">GitHub</li>
                <li class="landing-page-platform-name" (click)="displayPlatformPage('Technical', 'Stack Overflow')">Stack Overflow</li>
                <li class="landing-page-platform-name" (click)="displayPlatformPage('Technical', 'ResearchGate')">ResearchGate</li>
              </div>
              <div class="col position-relative">
                <img src="./../../../assets/search/toolbox-v2/technical-platforms.png"
                class="landing-page-platform-images position-absolute technical-rb5020">
              </div>
            </div>
            </div>
        </div>
         </div>
         <div class="row mb-6 pb-6">
          <div class="col-md-6">
            <div class="landing-page-platform-partitions2 wccard ml-auto  p-3">
              <h3 class="landing-page-platform-headings">Creative</h3>
              <p class="landing-page-platforms-description">
                Search designers and other creative professionals from platforms used to share portfolios.
              </p>
              <div class="row">
                <div class="col landing-page-platform-names-div">
                  <li class="landing-page-platform-name" (click)="displayPlatformPage('Creative', 'LinkedIn')">LinkedIn</li>
                  <li class="landing-page-platform-name" (click)="displayPlatformPage('Creative', 'Behance')">Behance</li>
                  <li class="landing-page-platform-name" (click)="displayPlatformPage('Creative', 'Dribbble')">Dribbble</li>
                </div>
                <div class="col">
                  <img src="./../../../assets/search/toolbox-v2/creative-platforms.png" class="landing-page-platform-images position-absolute creative-rb5020">
              </div>
            </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="landing-page-platform-partitions2 wccard  p-3">
              <h3 class="landing-page-platform-headings">Health Care</h3>
        <p class="landing-page-platforms-description">
          Search health care professionals from platforms catering to this specific domain.
        </p>
        <div class="row">
          <div class="col landing-page-platform-names-div">
            <li class="landing-page-platform-name" (click)="displayPlatformPage('Health Care', 'LinkedIn')">LinkedIn</li>
            <li class="landing-page-platform-name" (click)="displayPlatformPage('Health Care', 'Doximity')">Doximity</li>
            <li class="landing-page-platform-name" (click)="displayPlatformPage('Health Care', 'HealthProfs')">HealthProfs</li>
          </div>
          <div class="col">
            <img src="./../../../assets/search/toolbox-v2/healthcare-platforms.png"
                  class="landing-page-platform-images position-absolute healthcare-rb5020">
                </div>
              </div>
              </div>
          </div>
           </div>
      </div>
    </div>
  </div>
</div>

<!-- History Page -->
<div *ngIf="showSearchHistoryPage">
  <div class="col-12 wccard py-1 mb-3px">
    <div class="d-flex justify-content-between mb-1 mt-1">
      <div class="d-flex">
      <i class="fas fa-arrow-left mr-3 mt-1 pointer" (click)="goBackFromHistoryPage()"></i>
       <span class="f-14 mt-3px font-weight-500 d-flex justify-content-between pointer"> Back
      </span>
    </div>
    <div class="">
      <div *ngIf="totalHistoryRecordsCount > 0" class="d-flex">
        <span class="px-2 mr-2 mt-3px">
          <div  *ngIf="total > 10 && totalHistoryRecordsCount > 9">
          <span class="font-weight-600">{{start+1}}-{{end}}</span> of {{total}} results
          </div>
        </span>
        <span class="px-2 f-20" *ngIf="totalHistoryRecordsCount > 9" >
          <a data-testid="auto-app-searchtoolbox-v2-a-1" (click)="start > 0 && pagination('prev')" class="mr-1 text-black"><i class="fas fa-caret-left"></i></a>
          &nbsp;
          <a data-testid="auto-app-searchtoolbox-v2-a-2" (click)="end < total && pagination('next')" class="ml-1 text-black"><i
              class="fas fa-caret-right"></i></a>
        </span>
      </div>
    </div>
    </div>
  </div>

<section *ngIf="searchToolboxHistory.length > 0">
  <div class="col-12 wccard mb-3px pb-0 oncardlistHover position-relative mt-02 pb-3" *ngFor="let history of searchToolboxHistory;let i = index">

    <div class="mb-2 mt-4" *ngIf="history.lastname || history.firstname">
      <div class="d-flex justify-content-between">
        <div class="col-md-8 px-0">
          <table>
            <tr>
              <td valign="top" class="td-width-200 "><span class="">
                  <span class="gray-text f-14"> Platform Accessed: </span> </span></td>
              <td>
                <span class="f-14"> People Search </span>
              </td>
            </tr>
            <tr style="height: 10px;"></tr>
          </table>
        </div>
        <div class="">
          <span class="mr-1 f-12"><i class="fas fa-clock greybg"> </i> {{history.updatedon}} </span>
          <span class="wc-btn bg-blue onhverNotesEllipsis position-absolute mt-5" (click)="repeatSearch(history)"
            style="right: 15px;"> Search </span>
        </div>
      </div>

      <div class="row mb-2 justify-content-between">
        <div class="col-md-6">
          <table>
            <tr>
              <td valign="top" class="td-width-200 "><span class="">
                  <span class="gray-text f-14 pb-2"> First Name: </span> </span></td>
              <td>
                <span class="f-14">{{history.firstname}} </span>
              </td>
            </tr>
          </table>
        </div>

        <div class="col-md-6">
          <table>
            <tr>
              <td valign="top" class="td-width-200"><span class="">
                  <span class="gray-text f-14"> Last Name: </span> </span></td>
              <td>
                <span class="f-14"> {{history.lastname}} </span>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>

    <div class="d-flex justify-content-between mb-2 mt-4" *ngIf="!(history.lastname && history.firstname)">
      <div class="" >
        <table>
          <tr>
            <td valign="top" class="td-width-200 "><span class="">
              <span class="gray-text f-14"> Platform Accessed: </span>

            </span></td>
            <td>
              <span class="f-14" *ngIf='history.searchtoolboxversion != "v2.0"'> LinkedIn </span>
              <span class="f-14" *ngIf='history.searchtoolboxversion == "v2.0"'> {{history.platformsaccessed}} </span>
              <span class="f-14 text-dis" *ngIf='!history.platformsaccessed'> Not available  </span>
            </td>
          </tr>

        </table>
      </div>
      <div class="">
        <span class="mr-1 f-12"><i class="fas fa-clock greybg"> </i> {{history.updatedon}} </span>
      </div>
    </div>

    <div class="row mt-2 justify-content-between"  *ngIf="!(history.lastname && history.firstname)">
      <div class="col-md-8 mb-2">
        <table>
          <tr>
            <td valign="top"  class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text"> Preferred Skills: </span>

                </span>
            </td>
            <td><span class="f-14">  {{history.preferredskills }} </span>
              <span class="f-14 text-dis" *ngIf='!history.preferredskills'> Not available  </span></td>
          </tr>
        </table>
      </div>
      <div class="col-md-4 text-right d-flex justify-content-end position-relative" *ngIf="!(history.lastname && history.firstname)">
      <span class="wc-btn bg-blue onhverNotesEllipsis position-absolute mt-3 z-99" (click)="repeatSearch(history)"> Search </span>
      </div>
    </div>

    <div class="row justify-content-between"  *ngIf="!(history.lastname && history.firstname)">
      <div class="col-md-8 mb-2">

        <table>
          <tr>
            <td valign="top" class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text"> Mandatory Skills: </span>

                </span>
            </td>
            <td><span class="f-14">  {{history.mandatoryskills }} </span>
              <span class="f-14 text-dis" *ngIf='!history.mandatoryskills'> Not available  </span></td>
          </tr>
        </table>

      </div>
    </div>

    <div *ngIf="(history.platformsaccessed != 'GitHub') || (history.platformsaccessed == 'Doximity' || history.platformsaccessed == 'ResearchGate')"
      class="row mb-2 justify-content-between">
      <div *ngIf="history.platformsaccessed != 'GitHub'" class="col-md-6">
        <table>
          <tr>
            <td valign="top" class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text"> Job Titles: </span>

                </span>
            </td>
            <td><span class="f-14">  {{history.jobtitles }} </span>
              <span class="f-14 text-dis" *ngIf='!history.jobtitles'> Not available  </span></td>
          </tr>
        </table>

      </div>
      <div *ngIf="(history.platformsaccessed == 'Doximity' || history.platformsaccessed == 'ResearchGate'  || history.firstname || history.lastname)" class="col-md-6">
        <table>
          <tr>
            <td valign="top" class="td-width-200">

                <span class=" f-14">
                  <span class="gray-text"> Educational Degrees: </span>

                </span>
            </td>
            <td> <span class="f-14"> {{history.educationaldegrees}} </span>
              <span class="f-14 text-dis" *ngIf='!history.educationaldegrees'> Not available  </span></td>
          </tr>
        </table>

      </div>
    </div>

    <div *ngIf="(history.platformsaccessed == 'LinkedIn' || history.platformsaccessed == 'Xing' || history.platformsaccessed == 'Quora' || history.platformsaccessed == 'Twitter')"
      class="row mb-2">
      <div *ngIf="(history.platformsaccessed == 'LinkedIn' || history.platformsaccessed == 'Xing' || history.platformsaccessed == 'Quora' || history.platformsaccessed == 'Twitter')" class="col-md-6">
        <table>
          <tr>
            <td valign="top" class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text"> Company Names: </span>

                </span>
            </td>
            <td> <span class="f-14"> {{history.companies }} </span>
              <span class="f-14 text-dis" *ngIf='!history.companies'> Not available  </span></td>
          </tr>
        </table>

      </div>
      <div *ngIf="(history.platformsaccessed == 'LinkedIn' || history.platformsaccessed == 'Xing') && !(history.lastname && history.firstname)" class="col-md-6">
        <table>
          <tr>
            <td class="td-width-200">

                <span class=" f-14">
                  <span class="gray-text">Industry Sector:  </span>

                </span>
            </td>
            <td> <span class="f-14" *ngFor="let x of history.industries ; let isLast=last">  {{x.industry_name}}
              {{isLast ? '' : '; '}}
            </span>
            <span class="f-14 text-dis" *ngIf='!history.industries || !history.industries.length'> Not available  </span></td>
          </tr>
        </table>

      </div>
    </div>

    <div *ngIf="(history.platformsaccessed == 'Doximity') || (history.platformsaccessed != 'Doximity' || history.platformsaccessed != 'HealthProfs')"
      class="row mb-2">
      <div *ngIf="(history.platformsaccessed == 'Doximity')" class="col-md-6">
        <table>
          <tr>
            <td valign="top" class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text">Gender:  </span>

                </span>
            </td>
            <td> <span class="f-14" *ngFor="let x of history.industries ; let isLast=last">  {{x.industry_name}}
              {{isLast ? '' : '; '}}
            </span>
            <span class="f-14 text-dis" *ngIf='!history.industries || !history.industries.length'> Not available  </span></td>
          </tr>
        </table>

      </div>
      <div *ngIf="(history.platformsaccessed != 'Doximity' || history.platformsaccessed != 'HealthProfs')" class="col-md-6">
        <table>
          <tr>
            <td valign="top" class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text">Location Names:   </span>

                </span>
            </td>
            <td>  <span class="f-14"> {{history.locations }} </span>
              <span class="f-14 text-dis" *ngIf='!history.locations'> Not available  </span></td>
          </tr>
        </table>

      </div>
    </div>

    <div *ngIf="(history.platformsaccessed == 'GitHub' || history.platformsaccessed == 'LinkedIn')" class="row">
      <div *ngIf="history.platformsaccessed == 'GitHub'" class="col-md-6 mb-2">
        <table>
          <tr>
            <td valign="top" class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text">Programming Languages:    </span>

                </span>
            </td>
            <td> <span class="f-14"> {{history.programminglanguages }} </span>
              <span class="f-14 text-dis" *ngIf='!history.programminglanguages'> Not available  </span></td>
          </tr>
        </table>

      </div>
      <div *ngIf="history.platformsaccessed == 'LinkedIn' && !(history.lastname && history.firstname)" class="col-md-6  mb-2">
        <table>
          <tr>
            <td valign="top" class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text">Spoken Languages:   </span>

                </span>
            </td>
            <td>  <span class="f-14"> {{history.spokenlanguages}} </span>
              <span class="f-14 text-dis" *ngIf='!history.spokenlanguages'> Not available  </span></td>
          </tr>
        </table>

      </div>
    </div>

    <div *ngIf="(history.platformsaccessed == 'LinkedIn' || history.platformsaccessed == 'ResearchGate') || (history.resumecheckbox == 1 && history.platformsaccessed == 'Behance')"
      class="row mb-2">
      <div *ngIf="(history.platformsaccessed == 'LinkedIn' || history.platformsaccessed == 'ResearchGate')" class="col-md-6">
        <table>
          <tr>
            <td valign="top" class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text"> Institutes:   </span>

                </span>
            </td>
            <td> <span class="f-14"> {{history.schools }} </span>
              <span class="f-14 text-dis" *ngIf='!history.schools'> Not available  </span></td>
          </tr>
        </table>

      </div>
      <div *ngIf="(history.resumecheckbox == 1 && history.platformsaccessed == 'Behance')" class="col-md-6">
        <table>
          <tr>
            <td valign="top" class="td-width-200 ">

                <span class=" f-14">
                  <span class="gray-text">  Show profiles with Resume:  </span>

                </span>
            </td>
            <td>  <span class="f-14"> Yes </span></td>
          </tr>
        </table>

      </div>
    </div>

  </div>
</section>

  <div *ngIf="searchToolboxHistory.length == 0">
    <div class="col wccard text-center pt-1">
      <div class="row mt-3">
        <div class="col py-6">
          <img src="../../../assets/images/search-engine-1.png" class="img-fluid" alt="" srcset="">
        </div>
      </div>
      <div class="pb-4">
        <p class="font-weight-500 f-14 py-3 gray-text">Nothing to see here</p>
      </div>
 </div>
  </div>

</div>

<!-- Platform Page -->
<div class="row content">
  <div class="col-md-9 pr-1">
    <!-- Platform page form -->
    <div *ngIf="!showSearchHistoryPage && showSearchPlatformPage" class="pr-01">
      <div class="col wccard py-2 mb-3px">
        <div class="row mb-3px">
          <div class="col d-flex justify-content-start">
            <i class="fas fa-arrow-left mr-2 mt-2 pointer"
            (click)="returnToLandingPage()"></i>
            <span class="f-18 mb-0 font-weight-500 d-flex justify-content-between mt-3px platform-type-heading"> {{selectedPlatformType}}</span>
          </div>
          <div class="col d-flex justify-content-end">
            <span class="wc-btn history-button" (click)="showHistoryPage('platformPage')"> History </span>
          </div>
        </div>
      </div>

      <div class="platform-page-background" *ngIf="selectedPlatformType == 'Person Search'">
        <div class="col wccard mb-3px pb-8 pt-3">
          <!-- Input Fields -->
          <div class="row mb-4 mr-50">
            <div class="col-6">
              <label class="font-weight-500 f-12 mb-1 mt-3">First Name <span class="text-danger ml-1">*</span></label>
              <div class="position-relative">
                <input data-testid="auto-app-searchtoolbox-v2-input-1" type="text" placeholder="Enter First Name" class="wc-form-control nobg mt-3px"
                [(ngModel)]="fname">
              </div>
            </div>

            <div class="col-6">
              <label class="font-weight-500 f-12 mb-1 mt-3">Last Name <span class="text-danger ml-1">*</span></label>
              <div class="position-relative">
                <input data-testid="auto-app-searchtoolbox-v2-input-2" type="text" placeholder="Enter Last Name" class="wc-form-control nobg mt-3px"
                [(ngModel)]="lname">
              </div>
            </div>
          </div>

          <div class="row mb-4 mr-50">
            <div class="col-6">
              <label class="font-weight-500 f-12 mb-1 mt-3">Company Name </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')" placeholder = "E.g. Wipro" field="company_name"
                  (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                  <ng-template let-companies pTemplate="item">
                    <div class="country-item">
                        <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                        <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                    </div>
                </ng-template>
              </p-autoComplete>
              </div>
            </div>

            <div class="col-6">
              <label class="font-weight-500 f-12 mb-1 mt-3">Designation </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "E.g Java developer"
                  (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                  (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
              </div>
            </div>
          </div>

          <div class="row mb-4 mr-50">
            <div class="col-6">
              <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "E.g. India"
                (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
              </div>
            </div>

            <div class="col-3">
              <label class="font-weight-500 f-12 mb-1 mt-3">Education </label>
              <div class="position-relative">
                  <p-autoComplete [(ngModel)]="educationalDegree" [suggestions]="filteredEducationalDegreeOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'EducationalDegree')" placeholder = "E.g Birla school"
                  (completeMethod)="searchAutoCompletedData($event , 'EducationalDegree')" [multiple]="true"></p-autoComplete>
              </div>
            </div>

            <div class="col-3">
              <label class="font-weight-500 f-12 mb-1 mt-3">Institutes </label>
              <div class="position-relative">
                  <p-autoComplete [(ngModel)]="institute" [suggestions]="filteredInstituteOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Institute')" placeholder = "E.g University of Mumbai"
                  (completeMethod)="searchAutoCompletedData($event , 'Institute')" [multiple]="true"></p-autoComplete>
              </div>
            </div>
          </div>

          <div>
            <button data-testid="auto-app-searchtoolbox-v2-button-2" class="btn-trms-small m-auto" (click)="googleCustomSearchAPI('initial', 'linkedInSearch')">Search</button>
            &nbsp; &nbsp;
            <button data-testid="auto-app-searchtoolbox-v2-button-3" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
          </div>

          <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError"> First name and Last name is mandatory
          </div>

        </div>
      </div>

      <div class="platform-page-background" *ngIf="selectedPlatformType == 'General'">
        <div class="wccard px-3 mb-3px pt-2">
        <div class="row">
          <div class="col platform-tabs">
            <ul class="nav nav-pills">
              <li class="nav-item mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-3" class="nav-link" id="pills-linkedin-tab" data-bs-toggle="pill" href="#pills-linkedin" role="tab"
                  [ngClass]="{'active': tabToShow == 'LinkedIn'}" aria-controls="pills-linkedin"
                  aria-selected="true" (click)="updateTabToShow('General', 'LinkedIn')">LinkedIn</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-4" class="nav-link" id="pills-xing-tab" data-bs-toggle="pill" href="#pills-xing" role="tab"
                  [ngClass]="{'active': tabToShow == 'Xing'}" aria-controls="pills-xing"
                  aria-selected="false" (click)="updateTabToShow('General', 'Xing')">Xing</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-5" class="nav-link" id="pills-quora-tab" data-bs-toggle="pill" href="#pills-quora" role="tab"
                  [ngClass]="{'active': tabToShow == 'Quora'}" aria-controls="pills-quora"
                  aria-selected="false" (click)="updateTabToShow('General', 'Quora')">Quora</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-6" class="nav-link" id="pills-twitter-tab" data-bs-toggle="pill" href="#pills-twitter" role="tab"
                  [ngClass]="{'active': tabToShow == 'Twitter'}" aria-controls="pills-twitter"
                  aria-selected="false" (click)="updateTabToShow('General', 'Twitter')">Twitter</a>
              </li>
            </ul>
          </div>
          <div class="col-3 d-flex justify-content-end">
            <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
          </div>
        </div>
      </div>
        <div class="tab-content" id="pills-tabContent">
          <!-- LinkedIn -->
          <div class="tab-pane fade" id="pills-linkedin" role="tabpanel" aria-labelledby="pills-linkedin-tab"
            [ngClass]="{'show active': tabToShow == 'LinkedIn'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>


              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')" placeholder = "Type minimum 3 characters to get suggestions" field="company_name"
                      (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                      <ng-template let-companies pTemplate="item">
                        <div class="country-item">
                            <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                            <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                        </div>
                    </ng-template>
                  </p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Industries </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="industry" [suggestions]="filteredIndustryOption"
                      [style]="{'width':'100%'}" (completeMethod)="searchAutoCompletedData($event , 'Industry')"  placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Industry')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Institutes </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="institute" [suggestions]="filteredInstituteOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Institute')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Institute')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Spoken Languages </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="spokenLanguage" [suggestions]="filteredSpokenLanguageOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'SpokenLanguage')" placeholder = "Type minimum 1 character to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'SpokenLanguage')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-4" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'linkedInSearch')">Search talents on LinkedIn</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-5" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- Xing -->
          <div class="tab-pane fade" id="pills-xing" role="tabpanel" aria-labelledby="pills-xing-tab"
            [ngClass]="{'show active': tabToShow == 'Xing'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>


              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')" placeholder = "Type minimum 3 characters to get suggestions" field="company_name"
                      (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                      <ng-template let-companies pTemplate="item">
                        <div class="country-item">
                            <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                            <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                        </div>
                    </ng-template>
                  </p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Industries </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="industry" [suggestions]="filteredIndustryOption"
                      [style]="{'width':'100%'}" (completeMethod)="searchAutoCompletedData($event , 'Industry')"  placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Industry')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-6" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'xingSearch')">Search talents on Xing</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-7" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- Quora -->
          <div class="tab-pane fade" id="pills-quora" role="tabpanel" aria-labelledby="pills-quora-tab"
            [ngClass]="{'show active': tabToShow == 'Quora'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')" placeholder = "Type minimum 3 characters to get suggestions" field="company_name"
                      (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                      <ng-template let-companies pTemplate="item">
                        <div class="country-item">
                            <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                            <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                        </div>
                    </ng-template>
                  </p-autoComplete>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-8" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'quoraSearch')">Search talents on Quora</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-9" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- Twitter -->
          <div class="tab-pane fade" id="pills-twitter" role="tabpanel" aria-labelledby="pills-twitter-tab"
            [ngClass]="{'show active': tabToShow == 'Twitter'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')" placeholder = "Type minimum 3 characters to get suggestions" field="company_name"
                      (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                      <ng-template let-companies pTemplate="item">
                        <div class="country-item">
                            <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                            <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                        </div>
                    </ng-template>
                  </p-autoComplete>
                  </div>
                </div>

              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-10" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'twitterSearch')">Search talents on Twitter</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-11" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="platform-page-background" *ngIf="selectedPlatformType == 'Technical'">
        <div class="wccard px-3 mb-3px pt-2">
        <div class="row">
          <div class="col platform-tabs">
            <ul class="nav nav-pills">
              <li class="nav-item mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-7" class="nav-link" id="pills-linkedin-tab" data-bs-toggle="pill" href="#pills-linkedin" role="tab"
                  [ngClass]="{'active': tabToShow == 'LinkedIn'}" aria-controls="pills-linkedin"
                  aria-selected="true" (click)="updateTabToShow('Technical', 'LinkedIn')">LinkedIn</a>
              </li>
              <li class="nav-item mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-8" class="nav-link" id="pills-angelList-tab" data-bs-toggle="pill" href="#pills-angelList" role="tab"
                  [ngClass]="{'active': tabToShow == 'AngelList'}" aria-controls="pills-angelList"
                  aria-selected="false" (click)="updateTabToShow('Technical', 'AngelList')">AngelList</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-9" class="nav-link" id="pills-kaggle-tab" data-bs-toggle="pill" href="#pills-kaggle" role="tab"
                  [ngClass]="{'active': tabToShow == 'Kaggle'}" aria-controls="pills-kaggle"
                  aria-selected="false" (click)="updateTabToShow('Technical', 'Kaggle')">Kaggle</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-10" class="nav-link" id="pills-gitHub-tab" data-bs-toggle="pill" href="#pills-gitHub" role="tab"
                  [ngClass]="{'active': tabToShow == 'GitHub'}" aria-controls="pills-gitHub"
                  aria-selected="false" (click)="updateTabToShow('Technical', 'GitHub')">GitHub</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-11" class="nav-link" id="pills-stackOverflow-tab" data-bs-toggle="pill" href="#pills-stackOverflow" role="tab"
                  [ngClass]="{'active': tabToShow == 'Stack Overflow'}" aria-controls="pills-stackOverflow"
                  aria-selected="false" (click)="updateTabToShow('Technical', 'Stack Overflow')">Stack Overflow</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-12" class="nav-link" id="pills-researchGate-tab" data-bs-toggle="pill" href="#pills-researchGate" role="tab"
                  [ngClass]="{'active': tabToShow == 'ResearchGate'}" aria-controls="pills-researchGate"
                  aria-selected="false" (click)="updateTabToShow('Technical', 'ResearchGate')">ResearchGate</a>
              </li>
            </ul>
          </div>
          <div class="col-3 d-flex justify-content-end">
            <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
          </div>
        </div>
        </div>
        <div class="tab-content" id="pills-tabContent">
          <!-- LinkedIn -->
          <div class="tab-pane fade" id="pills-linkedin" role="tabpanel" aria-labelledby="pills-linkedin-tab"
            [ngClass]="{'show active': tabToShow == 'LinkedIn'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Skill');"  *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"  ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')" placeholder = "Type minimum 3 characters to get suggestions" field="company_name"
                      (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                      <ng-template let-companies pTemplate="item">
                        <div class="country-item">
                            <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                            <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                        </div>
                    </ng-template>
                  </p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Industries </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="industry" [suggestions]="filteredIndustryOption"
                      [style]="{'width':'100%'}" (completeMethod)="searchAutoCompletedData($event , 'Industry')"  placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Industry')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Institutes </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="institute" [suggestions]="filteredInstituteOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Institute')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Institute')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Spoken Languages </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="spokenLanguage" [suggestions]="filteredSpokenLanguageOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'SpokenLanguage')" placeholder = "Type minimum 1 character to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'SpokenLanguage')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-12" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'linkedInSearch')">Search talents on LinkedIn</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-13" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- AngelList -->
          <div class="tab-pane fade" id="pills-angelList" role="tabpanel" aria-labelledby="pills-angelList-tab"
            [ngClass]="{'show active': tabToShow == 'AngelList'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-14" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'angelListSearch')">Search talents on AngelList</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-15" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- Kaggle -->
          <div class="tab-pane fade" id="pills-kaggle" role="tabpanel" aria-labelledby="pills-kaggle-tab"
            [ngClass]="{'show active': tabToShow == 'Kaggle'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "(click)="addRecommendedSuggestionChip(i , skills, 'Skill');"  *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
              </div>


              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-16" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'kaggleSearch')">Search talents on Kaggle</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-17" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- GitHub -->
          <div class="tab-pane fade" id="pills-gitHub" role="tabpanel" aria-labelledby="pills-gitHub-tab"
            [ngClass]="{'show active': tabToShow == 'GitHub'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Programming Languages </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="programmingLanguage" [suggestions]="filteredProgrammingLanguageOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'ProgrammingLanguage')" placeholder = "Type minimum 1 character to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'ProgrammingLanguage')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>



              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-18" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'githubSearch')">Search talents on GitHub</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-19" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- Stack Overflow -->
          <div class="tab-pane fade" id="pills-stackOverflow" role="tabpanel" aria-labelledby="pills-stackOverflow-tab"
            [ngClass]="{'show active': tabToShow == 'Stack Overflow'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
              </div>


              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-20" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'stackOverflowSearch')">Search talents on Stack Overflow</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-21" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- ResearchGate -->
          <div class="tab-pane fade" id="pills-researchGate" role="tabpanel" aria-labelledby="pills-researchGate-tab"
            [ngClass]="{'show active': tabToShow == 'ResearchGate'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Institutes </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="institute" [suggestions]="filteredInstituteOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Institute')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Institute')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Education </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="educationalDegree" [suggestions]="filteredEducationalDegreeOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'EducationalDegree')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'EducationalDegree')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-22" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'researchGateSearch')">Search talents on ResearchGate</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-23" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="platform-page-background" *ngIf="selectedPlatformType == 'Creative'">
        <div class="wccard px-3 mb-3px pt-2">
        <div class="row">
          <div class="col platform-tabs">
            <ul class="nav nav-pills">
              <li class="nav-item mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-13" class="nav-link" id="pills-linkedin-tab" data-bs-toggle="pill" href="#pills-linkedin" role="tab"
                  [ngClass]="{'active': tabToShow == 'LinkedIn'}" aria-controls="pills-linkedin"
                  aria-selected="true" (click)="updateTabToShow('Creative', 'LinkedIn')">LinkedIn</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-14" class="nav-link" id="pills-behance-tab" data-bs-toggle="pill" href="#pills-behance" role="tab"
                  [ngClass]="{'active': tabToShow == 'Behance'}" aria-controls="pills-behance"
                  aria-selected="false" (click)="updateTabToShow('Creative', 'Behance')">Behance</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-15" class="nav-link" id="pills-dribbble-tab" data-bs-toggle="pill" href="#pills-dribbble" role="tab"
                  [ngClass]="{'active': tabToShow == 'Dribbble'}" aria-controls="pills-dribbble"
                  aria-selected="false" (click)="updateTabToShow('Creative', 'Dribbble')">Dribbble</a>
              </li>
            </ul>
          </div>
          <div class="col-3 d-flex justify-content-end">
            <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
          </div>
        </div>
      </div>
        <div class="tab-content" id="pills-tabContent">
          <!-- LinkedIn -->
          <div class="tab-pane fade" id="pills-linkedin" role="tabpanel" aria-labelledby="pills-linkedin-tab"
            [ngClass]="{'show active': tabToShow == 'LinkedIn'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')" placeholder = "Type minimum 3 characters to get suggestions" field="company_name"
                      (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                      <ng-template let-companies pTemplate="item">
                        <div class="country-item">
                            <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                            <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                        </div>
                    </ng-template>
                  </p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Industries </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="industry" [suggestions]="filteredIndustryOption" [style]="{'width':'100%'}"
                      (completeMethod)="searchAutoCompletedData($event , 'Industry')"  placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Industry')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Institutes </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="institute" [suggestions]="filteredInstituteOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Institute')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Institute')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Spoken Languages </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="spokenLanguage" [suggestions]="filteredSpokenLanguageOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'SpokenLanguage')" placeholder = "Type minimum 1 character to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'SpokenLanguage')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-24" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'linkedInSearch')">Search talents on LinkedIn</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-25" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- Behance -->
          <div class="tab-pane fade" id="pills-behance" role="tabpanel" aria-labelledby="pills-behance-tab"
            [ngClass]="{'show active': tabToShow == 'Behance'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6 d-flex align-items-center mb-2">
                  <div class="position-relative">
                    <label class="wc-checkbox mr-3 mb-0">
                      <input data-testid="auto-app-searchtoolbox-v2-input-3" type="checkbox" id="resumeCheckbox" [(ngModel)]="showResultsWithResume" name="resumeCheckbox" (click)="showResumeCheckbox($event);">
                      <i class="fas fa-check"></i>
                    </label>
                    <label for="resumeCheckbox" class="font-weight-500 f-12 mb-1 mt-3">Show profiles with Resume </label>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-26" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'behanceSearch')">Search talents on Behance</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-27" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- Dribbble -->
          <div class="tab-pane fade" id="pills-dribbble" role="tabpanel" aria-labelledby="pills-dribbble-tab"
            [ngClass]="{'show active': tabToShow == 'Dribbble'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');"  *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-28" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'dribbbleSearch')">Search talents on Dribbble</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-29" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="platform-page-background" *ngIf="selectedPlatformType == 'Health Care'">
        <div class="wccard px-3 mb-3px pt-2">
        <div class="row">
          <div class="col platform-tabs">
            <ul class="nav nav-pills">
              <li class="nav-item mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-16" class="nav-link" id="pills-linkedin-tab" data-bs-toggle="pill" href="#pills-linkedin" role="tab"
                  [ngClass]="{'active': tabToShow == 'LinkedIn'}" aria-controls="pills-linkedin"
                  aria-selected="true" (click)="updateTabToShow('Health Care', 'LinkedIn')">LinkedIn</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-17" class="nav-link" id="pills-doximity-tab" data-bs-toggle="pill" href="#pills-doximity" role="tab"
                  [ngClass]="{'active': tabToShow == 'Doximity'}" aria-controls="pills-doximity"
                  aria-selected="false" (click)="updateTabToShow('Health Care', 'Doximity')">Doximity</a>
              </li>
              <li class="nav-item  mr-3">
                <a data-testid="auto-app-searchtoolbox-v2-a-18" class="nav-link" id="pills-healthProfs-tab" data-bs-toggle="pill" href="#pills-healthProfs" role="tab"
                  [ngClass]="{'active': tabToShow == 'HealthProfs'}" aria-controls="pills-healthProfs"
                  aria-selected="false" (click)="updateTabToShow('Health Care', 'HealthProfs')">HealthProfs</a>
              </li>
            </ul>
          </div>
          <div class="col-3 d-flex justify-content-end">
            <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
          </div>
        </div>
        </div>
        <div class="tab-content" id="pills-tabContent">
          <!-- LinkedIn -->
          <div class="tab-pane fade" id="pills-linkedin" role="tabpanel" aria-labelledby="pills-linkedin-tab"
            [ngClass]="{'show active': tabToShow == 'LinkedIn'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                    (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')" placeholder = "Type minimum 3 characters to get suggestions"
                    (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')" placeholder = "Type minimum 3 characters to get suggestions" field="company_name"
                      (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                      <ng-template let-companies pTemplate="item">
                        <div class="country-item">
                            <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                            <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                        </div>
                    </ng-template>
                  </p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Industries </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="industry" [suggestions]="filteredIndustryOption"
                      [style]="{'width':'100%'}" (completeMethod)="searchAutoCompletedData($event , 'Industry')"  placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Industry')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Institutes </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="institute" [suggestions]="filteredInstituteOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Institute')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Institute')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Spoken Languages </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="spokenLanguage" [suggestions]="filteredSpokenLanguageOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'SpokenLanguage')" placeholder = "Type minimum 1 character to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'SpokenLanguage')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-30" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'linkedInSearch')">Search talents on LinkedIn</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-31" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- Doximity -->
          <div class="tab-pane fade" id="pills-doximity" role="tabpanel" aria-labelledby="pills-doximity-tab"
            [ngClass]="{'show active': tabToShow == 'Doximity'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Education </label>
                  <div class="position-relative">
                      <p-autoComplete [(ngModel)]="educationalDegree" [suggestions]="filteredEducationalDegreeOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'EducationalDegree')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'EducationalDegree')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Gender </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="gender" [suggestions]="filteredGenderOption" [style]="{'width':'100%'}"
                      placeholder = "Type minimum 1 character to get suggestions" [multiple]="true"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Gender')" (completeMethod)="searchAutoCompletedData($event , 'Gender')">
                    </p-autoComplete>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-32" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'doximitySearch')">Search talents on Doximity</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-33" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError">Please select at least 1 preferred skill
              </div>
            </div>

          </div>

          <!-- HealthProfs -->
          <div class="tab-pane fade" id="pills-healthProfs" role="tabpanel" aria-labelledby="pills-healthProfs-tab"
            [ngClass]="{'show active': tabToShow == 'HealthProfs'}">

            <div class="col wccard mb-3px pb-8">
              <!-- Input Fields -->
              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="removeSelectedChip($event,'Job Title')"
                      (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip" class="text-danger">*</span> (Include profiles with any of these skills) </label>
                  <ng-template #preferredSkillsTooltip>
                    <span class="f-12"> Select at least 1 preferred skill </span>
                  </ng-template>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                      [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>

                <!-- <div class="col-3 d-flex justify-content-end mr-3">
                  <span class="wc-btn jd-search-button" (click)="addJobDescription()"> Search using JD </span>
                </div> -->
              </div>

              <!-- Suggestions Row -->
              <div class="row mb-4 mr-50" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                        ></i> </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50">
                <div class="col-6">
                  <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills) </label>
                  <div class="position-relative">
                    <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'100%'}"
                      (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"  (onUnselect)="removeSelectedChip($event,'Skill')"
                      (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 characters to get suggestions"
                      (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="row mb-4 mr-50" *ngIf="recommendedskills.length>0">
                <div class="col-6">
                  <div class="customChip mr-1 mt-1 "  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>
              </div>

              <div>
                <button data-testid="auto-app-searchtoolbox-v2-button-34" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'healthProfsSearch')">Search talents on HealthProfs</button>
                &nbsp; &nbsp;
                <button data-testid="auto-app-searchtoolbox-v2-button-35" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
              </div>

              <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError"> Please select at least 1 preferred skill
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Results section -->
    <div  #resultsSectionDiv class="results-section pr-01" *ngIf="!showSearchHistoryPage && showSearchResults">
      <div class="col wccard py-3">

        <div class="user-selected-options-div">

          <div *ngIf="selectedPlatformType == 'Person Search'" class="row justify-content-between">
            <div class="col-md-8 mb-2">
              <table>
                <tr>
                  <td valign="top" class="td-width-200">
                    <span class="gray-text mr-2"> First Name: </span>
                  </td>
                  <td> <span class="f-14"> {{fname }} </span></td>
                </tr>
              </table>
            </div>

            <div class="col-md-8 mb-2">
              <table>
                <tr>
                  <td valign="top" class="td-width-200">
                    <span class="gray-text mr-2"> Last Name: </span>
                  </td>
                  <td> <span class="f-14"> {{lname }} </span></td>
                </tr>
              </table>
            </div>
           </div>

          <div *ngIf="showUserSelectedJobTitles" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">
              <table>
                <tr>
                  <td valign="top" class="td-width-200">

                    <span class="gray-text mr-2"> Job Titles: </span>
                  </td>
                  <td> <span class="f-14"> {{userSelectedData.jobtitles }} </span></td>
                </tr>
              </table>

            </div>
          </div>

          <div *ngIf="showUserSelectedPreferredSkills" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">


                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2"> Preferred Skills: </span>
                    </td>

                  <td><span class="f-14"> {{userSelectedData.preferredskills }} </span> </td>
                  </tr>
                </table>
            </div>
          </div>

          <div *ngIf="showUserSelectedMandatorySkills" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">
                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2"> Mandatory Skills: </span>
                    </td>

                  <td><span class="f-14"> {{userSelectedData.mandatoryskills }} </span> </td>
                  </tr>
                </table>
            </div>
          </div>

          <div *ngIf="showUserSelectedLocations" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">

                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2"> Location Names: </span>
                    </td>

                  <td><span class="f-14">  {{userSelectedData.locations }} </span>
                  </tr>
                </table>
            </div>
          </div>

          <div *ngIf="showUserSelectedCompanies" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">

                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2">  Company Names: </span>
                    </td>

                  <td><span class="f-14">   {{userSelectedData.companies }} </span>
                  </tr>
                </table>
            </div>
          </div>

          <div *ngIf="showUserSelectedInstitutes" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">
                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2">  Institutes: </span>
                    </td>

                  <td><span class="f-14">   {{userSelectedData.schools }} </span>
                  </tr>
                </table>
            </div>
          </div>


          <div *ngIf="showUserSelectedGender" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">

                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2">  Gender: </span>
                    </td>

                  <td><span class="f-14">  {{userSelectedData.gender }} </span>
                  </tr>
                </table>
            </div>
          </div>


          <div *ngIf="showUserSelectedEducationalDegrees" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">

                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2">  Educational Degrees: </span>
                    </td>

                  <td><span class="f-14"> {{userSelectedData.educationaldegrees }} </span>
                </table>
            </div>
          </div>

          <div *ngIf="showUserSelectedIndustries" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">

                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2">  Industry Sector: </span>
                    </td>

                  <td><span class="f-14"> {{userSelectedData.industries }} </span>
                </table>
            </div>
          </div>


          <div *ngIf="showUserSelectedSpokenLanguages" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">
                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2">  Spoken Languages: </span>
                    </td>

                  <td><span class="f-14">  {{userSelectedData.spokenlanguages }} </span>
                </table>
            </div>
          </div>

          <div *ngIf="showUserSelectedProgrammingLanguages" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">

                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2">   Programming Skills: </span>
                    </td>

                  <td><span class="f-14">  {{userSelectedData.programminglanguages }} </span>
                </table>
            </div>
          </div>

          <div *ngIf="showUserSelectedResumeOption" class="row mb-1 justify-content-between">
            <div class="col-md-8 mb-2">
                <table>
                  <tr>
                    <td valign="top" class="td-width-200">

                      <span class="gray-text mr-2">  Show profiles with Resume: </span>
                    </td>

                  <td><span class="f-14">  Yes </span>
                </table>
            </div>
          </div>
        </div>
        <br>

        <div *ngIf="totalSearchResultsCount ==  0"> <br />
          <p>No result found. Please modify your Search Filters.</p>
        </div>

        <div [ngClass]="{'SearchScroll': searchResults.length > 10}" *ngIf="totalSearchResultsCount > 0" >
          <div class="d-flex justify-content-between py-4 mb-4">
            <span class="">
              <span *ngIf="tabToShow == 'LinkedIn'">
                <label class="wc-checkbox mr-3 mb-0">
                  <input data-testid="auto-app-searchtoolbox-v2-input-4" [(ngModel)]="selected" (change)="selectAll($event)" type="checkbox" id="mycheck" name="mycheck">
                  <i class="fas fa-check"></i>
                </label>
              </span>
              <span class="font-weight-500">
                {{totalSearchResultsCount}} Candidates Found
              </span>
            </span>
            <span class="wc-btn history-button" (click)="openGrabModal()"  *ngIf="candidatetoBeGrabbed?.length > 0 && tabToShow == 'LinkedIn'"> Grab
            </span>
          </div>
          <div *ngFor="let x of searchResults; let i = index">
            <div class="d-flex">
              <label class="wc-checkbox mr-3 my-auto" *ngIf="tabToShow == 'LinkedIn'">
                <input data-testid="auto-app-searchtoolbox-v2-input-5" [checked]="x.selected" [(ngModel)]="x.selected"
                  (change)="selectCandidate($event,x)" type="checkbox" id="mycheck" name="mycheck">
                <i class="fas fa-check"></i>
              </label>

              <div class="canProfilePic">
                <img *ngIf="(x.pagemap && x.pagemap.cse_thumbnail && x.pagemap.cse_thumbnail.length > 0)" src="{{x.pagemap.cse_thumbnail[0].src}}" alt="None"
                  class="img-search">
                <i class="fas fa-user" *ngIf="!(x.pagemap && x.pagemap.cse_thumbnail && x.pagemap.cse_thumbnail.length > 0)"></i>
              </div>
              <div class="col">
                <a data-testid="auto-app-searchtoolbox-v2-a-19" href="{{x?.formattedUrl}}" target="_blank" (click)="candidateCT(i)" class="font-weight-600 text-capitalize search-title"
                  [innerHtml]="x.htmlTitle">
                </a>
                <p><span class="ml7px f-12 font-weight-500" [innerHtml]="x.htmlSnippet"></span></p>
              </div>
            </div>
            <br /><br />
          </div>
        </div>

        <div class="d-flex mb-1 justify-content-center ">
          <ngb-pagination [collectionSize]="totalSearchResultsCount" [maxSize]="5" [pageSize]="20" [rotate]="true"
            (pageChange)="setPage($event)">
            <!-- <ng-template ngbPaginationPrevious> <span>
                <i class="fas fa-caret-left f-18"></i> Previous
              </span></ng-template>
            <ng-template ngbPaginationNext> <span>Next <i class="fas fa-caret-right f-18"></i></span> </ng-template> -->
          </ngb-pagination>
        </div>

        <!-- <span *ngIf="searchResultNextPage" class="pointer" (click)="googleCustomSearchAPI('nextPage')"> <i class="fas fa-angle-double-right" > </i> More Results
        </span> -->
      </div>
    </div>
  </div>

  <!------------------------------------------------ Information Placards ---------------------------------------------->
  <div *ngIf="!showSearchHistoryPage && showSearchPlatformPage" class="col-md-3 pl-1">
    <div class="mb-3 col wccard py-4 extn-info" *ngIf="selectedPlatformType == 'Person Search'">
      <p class="font-weight-500">
        <i class="fas fa-search mr-2"> </i>
          Person search
        </p>
        <p class="f-12 gray-text lh-18">
          Looking for the linkedin profile of someone you know using their details like name,
          designation , company etc.
          </p>
    </div>
    <div class="col wccard py-4 smart-info">
      <div class="col">
        <span class="row">
          <span class="mb-3">
            <span class="f-14 font-weight-500">  What does this help me with ?</span>
          </span>
          <div class="col-md-12 d-flex pl-0 mb-3">
            <span class="col-md-1 mb-3 pl-0 pr-0">
              <i class="fal fa-check mr-2"></i>
             </span>
              <span class="col-md-10 f-14 pl-0"> Easily Perform X-Ray search and get candidates across the web in this platform.
            </span>
          </div>

          <div class="col-md-12 d-flex pl-0 mb-3">
            <span class="col-md-1 mb-3 pl-0 pr-0">
              <i class="fal fa-check mr-2"></i>
             </span>
              <span class="col-md-10 f-14 pl-0">Get Candidates from multiple websites in one platform.
            </span>
          </div>

          <div class="col-md-12 d-flex pl-0 mb-3">
            <span class="col-md-1 mb-3 pl-0 pr-0" >
              <i class="fal fa-check mr-2"></i>
             </span>
              <span class="col-md-10 f-14 pl-0">  Narrow down your search and spot candidates with the preferable qualifications and skills.
            </span>
          </div>
        </span>
      </div>
    </div>

    <div class="col wccard py-4 mt-3 smart-info-ffd" *ngIf="selectedPlatformType != 'Person Search'">
      <div class="col">
        <span class="row">
          <span class="mb-3">
            <span class="f-14 font-weight-500">  Why search on {{tabToShow}} ?</span>
          </span>
          <div *ngIf="tabToShow == 'LinkedIn'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0"> LinkedIn is a business and employment-oriented online service that operates via websites and mobile apps.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">Search on LinkedIn to get profiles from different domains.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-1">
              <span class="col-md-1 mb-3 pl-0 pr-0" >
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">See Candidates that are not in your network on Linkedin.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0" >
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">No credits for searching.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'Xing'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">
                  Xing is a career-oriented social networking site.
                  Search on Xing to get profiles for different domains mainly from the Europe region.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'Quora'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">
                  Quora is a Q&A website where questions are asked, answered, followed and edited by Internet users,
                  either factually or in the form of opinions. Search on Quora to get profiles for different domains.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'Twitter'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">
                  Twitter is a social networking platform. Search on Twitter to find social profile links of the candidates
                  and search for their professional profiles across other paltforms.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'Behance'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">
                  Behance is a social media platform to showcase and discover creative work.
                  You can find creatives or UI/UX designers on this platform.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'Dribbble'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0"> Dribbble is a self-promoting and social networking platform for digital designers and creatives.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">It serves as a design portfolio platform, jobs & recruiting site and
                  is one of the largest platforms for designers to share their work online.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'Doximity'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0"> Doximity is an online networking service for medical professionals.
                  You can find medical professionals on this platform.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">The platform offers its members curated medical news, case collaboration and messaging capabilities.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'HealthProfs'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">
                  HealthProfs is an online platform that helps you find the correct medical professionals.
                  You can find medical professionals mainly from US on this platform and try to search for their profile across other professional platforms.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'AngelList'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">
                  AngelList is a marketplace for job seekers mainly for startups.
                  This makes AngelList a great place to search technical talent due to high number of tech startups.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'Kaggle'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">
                  Kaggle is a platform by Google specifically for the Data Science community.
                  Data Science enthusiasts and students use Kaggle to share projects, participate in competitions, etc.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'GitHub'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0"> GitHub is a platform used by the tech community for verison control during software development.
                  Thus it is used on a great extent to collaborate and share code.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">You can find great active tech talent on GitHub and search for their professional profiles across other platforms.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'Stack Overflow'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">
                  Stack Overflow is a Q&A site for software development enthusiasts and professionals.
                  You can find great active tech talent on Stack Overflow and search for their professional profiles across other platforms.
              </span>
            </div>
          </div>

          <div *ngIf="tabToShow == 'ResearchGate'">
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">
                  ResearchGate is a social networking site for scientists and researchers to share papers, ask & answer questions, and find collaborators.
                  You can search for talent from science community on this platform.
              </span>
            </div>
          </div>

        </span>
      </div>
    </div>
  </div>
</div>

<!-- Alert messages -->
<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>


<ng-template #noCreditsJDParse class="modal">
  <div class="modal-content">
      <div class="modal-body px-6 pb-6 pt-3">
          <div class="row mb-3">
              <div class="col pb-5">
                  <button data-testid="auto-app-searchtoolbox-v2-button-36" type="button" class="close position-absolute tr0" data-dismiss="modal"
                      aria-label="Close" (click)="modalService.dismissAll()">
                      <span aria-hidden="true">×</span>
                  </button>
              </div>
          </div>
          <div class="row mb-6">
              <div class="col text-center mb-4">
                  <img src="../../../assets/images/wallet.png" alt="img-fluid">
              </div>
          </div>
          <div class="row mb-3">
              <div class="col text-center ">
                  <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
                  <p class="">You have exhausted your limit for Search Using JD</p>
              </div>
          </div>
          <div class="row">
              <div class="col-md-10 mx-auto d-flex">
                  <button data-testid="auto-app-searchtoolbox-v2-button-37" class="btn-trms-medium m-auto" (click)="route2pricing()">Upgrade plan</button>
              </div>
          </div>
      </div>
  </div>
</ng-template>


<ng-template #noCreditsGrab class="modal">
  <div class="modal-content">
      <div class="modal-body px-6 pb-6 pt-3">
          <div class="row mb-3">
              <div class="col pb-5">
                  <button data-testid="auto-app-searchtoolbox-v2-button-38" type="button" class="close position-absolute tr0" data-dismiss="modal"
                      aria-label="Close" (click)="modalService.dismissAll()">
                      <span aria-hidden="true">×</span>
                  </button>
              </div>
          </div>
          <div class="row mb-6">
              <div class="col text-center mb-4">
                  <img src="../../../assets/images/wallet.png" alt="img-fluid">
              </div>
          </div>
          <div class="row mb-3">
              <div class="col text-center ">
                  <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
                  <p class="">You have exhausted your limit for Bulk Grabbing</p>
              </div>
          </div>
          <div class="row">
              <div class="col-md-10 mx-auto d-flex">
                  <button data-testid="auto-app-searchtoolbox-v2-button-39" class="btn-trms-medium m-auto" (click)="route2pricing()">Upgrade plan</button>
              </div>
          </div>
      </div>
  </div>
</ng-template>

<ng-template #grabModal class="modal">

  <div class="modal-content">
    <div class="modal-header b pb-0 px-6 pt-4">
      <h5 class="modal-title f-16 font-weight-600" id="team">Bulk grabbing</h5>
      <button data-testid="auto-app-searchtoolbox-v2-button-40" type="button" class="close py-3 font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="dismissBulkModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body px-3 pb-6 pt-2">
      <div class="gray-text col f-12 mb-2" style="line-height: 1.5;">
        This will grab the results in the background and directly add it to the talentpool that you select. We'll
        notify you by email once this is done. All the candidates that are found to be duplicates won't be grabbed.
      </div>
      <div class="col">
        <div class="f-12 font-weight-500 mb-2">
          <span *ngIf="candidatetoBeGrabbed?.length == 0">
            No of candidates
          </span>
          <span *ngIf="candidatetoBeGrabbed?.length > 0">
            Bulk candidates
          </span>
          <i class="fas fa-info-circle greybg ml-1" [ngbTooltip]="reserveCred" placement="right"
            tooltipClass="my-custom-class"></i>
          <ng-template #reserveCred>
            <span class="f-12"> These many candidates in the search result will be grabbed. All the candidates that already exist won’t be grabbed. </span>
          </ng-template>

          <input data-testid="auto-app-searchtoolbox-v2-input-6" type="text" placeholder="Enter no of candidates" class="wc-form-control nobg mt-1"
            [(ngModel)]="totalcandidatesForGrabString" style="pointer-events: none;border: none;
            padding-left: 0;
            font-weight: 500;"
            *ngIf="candidatetoBeGrabbed?.length > 0">

          <input data-testid="auto-app-searchtoolbox-v2-input-7" type="number" placeholder="Enter no of candidates" class="wc-form-control nobg mt-1"
            [(ngModel)]="totalcandidatesForGrab" *ngIf="candidatetoBeGrabbed?.length == 0">
        </div>
        <p class="text-danger f-12 mb-2"> {{ErrorMessage}}</p>

        <div class="f-12 font-weight-500 mb-4"> Select Talentpool
          <div class="position-relative">
            <div class="position-relative gray-text mt-3px">
              <input data-testid="auto-app-searchtoolbox-v2-input-8" (input)="getAllTalentpool()" type="text" placeholder="Select Talentpool" (click)="getAllTalentpool()"
                #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()" class="wc-form-control nobg"
                #talentpool [(ngModel)]="talentpoolname" [matAutocomplete]="talentpool_name">

              <mat-autocomplete #talentpool_name="matAutocomplete">
                <mat-option *ngFor="let talentpool of talentpoolslist" [value]="talentpool.name"
                  (onSelectionChange)="getAllTalentpool()">
                  {{talentpool.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <p *ngIf="noTalentpoolError" class="text-danger f-12">No Such Talentpool</p>
        </div>

        <div class="text-center">
          <button data-testid="auto-app-searchtoolbox-v2-button-41" class="btn-trms-small m-auto" (click)="doBulkExtraction()">OK</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #GrabInProgress class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-searchtoolbox-v2-button-42" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/data-hosting-two-color.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Grabbing already in progress</p>
          <p class="">You already have a grabbing running in the background. Please try grabbing these candidates after
            that is done.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-searchtoolbox-v2-button-43" class="btn-trms-small m-auto" (click)="modalService.dismissAll()">OK</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #GrabStarted class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-searchtoolbox-v2-button-44" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/undraw-uploading-go-67.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Grabbing has started</p>
          <p class="">We'll grab the profiles in background and add it to the talentpool. We'll notify you via email
            once it's done

          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-searchtoolbox-v2-button-45" class="btn-trms-small m-auto" (click)="modalService.dismissAll()">OK</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
